import { DatasetMetadataType } from '@routes/data-qa/datasets/dataset-metadata-type'
import { ILabelingInfo } from '@routes/data-qa/datasets/labeling-info'

export class HirundoCSV extends ILabelingInfo {
  public type: DatasetMetadataType.HirundoCSV = DatasetMetadataType.HirundoCSV
  public csvUrl: string = $state('')

  constructor(csvUrl?: string) {
    super()
    if (csvUrl) {
      this.csvUrl = csvUrl
    }
  }

  toJSON() {
    return {
      type: this.type,
      csvUrl: this.csvUrl,
    }
  }
}
